import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ServiceTestimonials = ({ services }) => {
  const [expandedTestimonial, setExpandedTestimonial] = useState(null);

  const testimonials = [
    {
      id: 'software-development',
      serviceTitle: 'Software Development',
      client: {
        name: 'Sarah Chen',
        position: 'CTO',
        company: 'TechFlow Solutions',
        avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face'
      },
      content: `RCEG AI Ventures transformed our legacy system into a modern, scalable platform. Their expertise in both traditional software development and AI integration was exactly what we needed. The team delivered on time and exceeded our performance expectations.`,
      rating: 5,
      metrics: {
        improvement: '300% faster processing',
        timeline: 'Delivered 2 weeks early',
        satisfaction: '98% user satisfaction'
      }
    },
    {
      id: 'ai-models',
      serviceTitle: 'AI Models & Machine Learning',
      client: {
        name: 'Michael Rodriguez',
        position: 'Head of Innovation',
        company: 'DataVision Corp',
        avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
      },
      content: `The custom AI model RCEG developed for our predictive analytics has revolutionized our decision-making process. Their deep understanding of machine learning algorithms and practical business applications is unmatched.`,
      rating: 5,
      metrics: {
        improvement: '85% prediction accuracy',
        timeline: '4-month implementation',
        satisfaction: 'ROI achieved in 6 months'
      }
    },
    {
      id: 'analytics',
      serviceTitle: 'Data Analytics & Intelligence',
      client: {
        name: 'Emily Watson',
        position: 'VP of Operations',
        company: 'RetailMax Inc',
        avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face'
      },
      content: `RCEG's analytics platform gave us insights we never knew we needed. The real-time dashboards and automated reporting have streamlined our operations and improved our strategic planning significantly.`,
      rating: 5,
      metrics: {
        improvement: '40% operational efficiency',timeline: 'Live in 8 weeks',satisfaction: '15% cost reduction'
      }
    },
    {
      id: 'cybersecurity',serviceTitle: 'Cybersecurity Solutions',
      client: {
        name: 'David Park',position: 'CISO',company: 'SecureBank Financial',avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
      },
      content: `RCEG's comprehensive security audit and implementation of AI-powered threat detection has significantly strengthened our security posture. Their proactive approach to cybersecurity is exactly what financial institutions need.`,
      rating: 5,
      metrics: {
        improvement: '99.9% threat detection',
        timeline: 'Zero security incidents',
        satisfaction: 'Compliance achieved'
      }
    },
    {
      id: 'ai-engineering',
      serviceTitle: 'AI Engineering & Integration',
      client: {
        name: 'Lisa Thompson',
        position: 'Chief Innovation Officer',
        company: 'ManufactureTech',
        avatar: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=150&h=150&fit=crop&crop=face'
      },
      content: `The AI engineering team at RCEG seamlessly integrated machine learning capabilities into our existing manufacturing processes. Their systematic approach to AI implementation minimized disruption while maximizing value.`,
      rating: 5,
      metrics: {
        improvement: '25% production efficiency',
        timeline: 'Phased 6-month rollout',
        satisfaction: '$2M annual savings'
      }
    }
  ];

  const toggleTestimonial = (testimonialId) => {
    setExpandedTestimonial(expandedTestimonial === testimonialId ? null : testimonialId);
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Icon
        key={index}
        name="Star"
        size={16}
        className={index < rating ? 'text-warning fill-current' : 'text-muted'}
      />
    ));
  };

  return (
    <div className="bg-white rounded-xl border border-border p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-success/10 flex items-center justify-center">
          <Icon name="MessageCircle" size={20} className="text-success" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">Client Success Stories</h3>
          <p className="text-sm text-muted-foreground">Real results from our service implementations</p>
        </div>
      </div>

      <div className="space-y-4">
        {testimonials.map((testimonial) => (
          <div key={testimonial.id} className="border border-border rounded-lg overflow-hidden">
            <button
              onClick={() => toggleTestimonial(testimonial.id)}
              className="w-full flex items-center justify-between p-4 text-left hover:bg-muted/30 transition-colors"
            >
              <div className="flex items-center space-x-4">
                <Image
                  src={testimonial.client.avatar}
                  alt={testimonial.client.name}
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div>
                  <div className="font-medium text-foreground">{testimonial.client.name}</div>
                  <div className="text-sm text-muted-foreground">
                    {testimonial.client.position} at {testimonial.client.company}
                  </div>
                  <div className="flex items-center space-x-1 mt-1">
                    {renderStars(testimonial.rating)}
                  </div>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <span className="text-xs font-medium text-primary bg-primary/10 px-2 py-1 rounded">
                  {testimonial.serviceTitle}
                </span>
                <Icon 
                  name={expandedTestimonial === testimonial.id ? 'ChevronUp' : 'ChevronDown'} 
                  size={16} 
                  className="text-muted-foreground" 
                />
              </div>
            </button>
            
            {expandedTestimonial === testimonial.id && (
              <div className="px-4 pb-4 border-t border-border">
                <blockquote className="text-muted-foreground italic leading-relaxed mt-3 mb-4">
                  "{testimonial.content}"
                </blockquote>
                
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                  <div className="bg-success/5 rounded-lg p-3 text-center">
                    <div className="text-sm font-semibold text-success">{testimonial.metrics.improvement}</div>
                    <div className="text-xs text-muted-foreground">Performance Gain</div>
                  </div>
                  <div className="bg-primary/5 rounded-lg p-3 text-center">
                    <div className="text-sm font-semibold text-primary">{testimonial.metrics.timeline}</div>
                    <div className="text-xs text-muted-foreground">Delivery</div>
                  </div>
                  <div className="bg-warning/5 rounded-lg p-3 text-center">
                    <div className="text-sm font-semibold text-warning">{testimonial.metrics.satisfaction}</div>
                    <div className="text-xs text-muted-foreground">Business Impact</div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="mt-6 pt-4 border-t border-border text-center">
        <p className="text-sm text-muted-foreground mb-3">
          Join 200+ companies that trust RCEG AI Ventures
        </p>
        <div className="flex items-center justify-center space-x-6 opacity-60">
          <div className="text-xs font-medium">TechFlow</div>
          <div className="text-xs font-medium">DataVision</div>
          <div className="text-xs font-medium">RetailMax</div>
          <div className="text-xs font-medium">SecureBank</div>
          <div className="text-xs font-medium">ManufactureTech</div>
        </div>
      </div>
    </div>
  );
};

export default ServiceTestimonials;